import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';
const MyVehicleType = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {

        setloading(true)
        ReadAxios({ url: 'vehicleTypeMaster', readItems: { searchTerm: '' } })
            .then((result) => {
                setcontent(result.data.resultSet)
                setloading(false)
            })
    }, [])
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.vehicleTypeCode
            temp.text = object.vehicleType + " " + "(" + object.vehicleTypeTonnage + ")"
            temp.value = object.vehicleTypeId
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
    }
    return (
        <Dropdown
            selection
            search
            clearable
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            error={props.error}
            noResultsMessage="Search for Result"
            {...props}
        />

    )
}

export default MyVehicleType